import {
  jb_news_page_hero_css_default
} from "./chunk.D4FTTUUA.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-news-page-hero/jb-news-page-hero.ts
var JbNewsPageHero = class extends Spaceable(i) {
  _getContentSpacingProperties() {
    return { grid: true, colsMdUp: 8, type: "no-vertical-space" };
  }
  render() {
    return b`<article>
      ${this.breadcrumbs && b`
          <jb-breadcrumbs .ariaLabels=${this.breadcrumbs.ariaLabels ?? A}>
            ${this.breadcrumbs.backlink && b`<jb-breadcrumbs-back-link
                .link=${this.breadcrumbs.backlink.link}
                .text=${this.breadcrumbs.backlink.text}
                slot="backlink"
              ></jb-breadcrumbs-back-link>`}
            ${this.breadcrumbs.items?.map(
      (breadcrumb) => b`<jb-breadcrumbs-item
                  .link=${breadcrumb.link}
                  .text=${breadcrumb.text}
                  slot="items"
                ></jb-breadcrumbs-item>`
    )}
          </jb-breadcrumbs>
        `}
      <header>
        <div class="intro-section">
          <jb-date date=${this.date}></jb-date>
          ${this.languages?.length && b`<jb-language-list
              .languages=${this.languages}
              .languageLabel=${this.languagesLabel}
            ></jb-language-list>`}
        </div>
      </header>
      <div class="title">
        ${this.subline && b`<p class="subline">${this.subline}</p>`}
        <jb-heading
          rank="1"
          variant="title"
          >${this.headline}</jb-heading
        >
      </div>
      ${this.shareBarLabel && b`<div class="toolbar">
          ${this.mailSubject && this.shareBarLabel && this.sharingUrl && b`
              <jb-article-share-bar
                .articleTitle=${this.headline}
                .mailSubject=${this.mailSubject}
                .title=${this.shareBarLabel}
                .shareServices=${this.shareServices}
                .url=${this.sharingUrl}
              ></jb-article-share-bar>
            `}
        </div>`}
      <div class="intro">${this.intro}</div>
      </div>
      <slot></slot>
    </article>`;
  }
};
JbNewsPageHero.styles = [reset_css_default, jb_news_page_hero_css_default];
__decorateClass([
  n({ type: Object })
], JbNewsPageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "date", 2);
__decorateClass([
  n({ reflect: true })
], JbNewsPageHero.prototype, "headline", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "intro", 2);
__decorateClass([
  n({ type: Array })
], JbNewsPageHero.prototype, "languages", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "languagesLabel", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "mailSubject", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "shareBarLabel", 2);
__decorateClass([
  n({ type: Array })
], JbNewsPageHero.prototype, "shareServices", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "sharingUrl", 2);
__decorateClass([
  n()
], JbNewsPageHero.prototype, "subline", 2);
JbNewsPageHero = __decorateClass([
  customElement("jb-news-page-hero")
], JbNewsPageHero);

export {
  JbNewsPageHero
};
